<template>
  <router-link  tag="div" :to="link">
    <md-card class="d-flex pb-3 pt-3 m-0 md-with-hover card-hover-white flex-column justify-content-center align-items-center">
      <img style="height: 100px" :src="img" :alt="titulo">
      <h6 class="bold mb-0 mt-1 md-body-2 text-primary text-center">{{ titulo }}</h6>
    </md-card>
  </router-link>
</template>

<script>
  export default {
    name: 'WidgetAtendimento',
    props: {
      titulo: { type: String, default: "Titulo" },
      img: { type: String, default: require('../assets/icon/empty_512_gray.png') },
      link: { type: String, default: "/" },
    }
  }
</script>
